export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/modules/home/views/pages/Home.vue'),
    meta: {
      title: 'Home',
      pagePermission: 'home',
      allowOnlyMercapromo: true,
    },
  },
]
